import styled from "styled-components/macro";

import {useState} from "react";
import {useToast} from "@chakra-ui/react";
import {useBaseCommunity} from "../../../store/hooks";
import HeaderData from "../../../components/header_data";
import Header from "../../../components/header";
import TopBar from "../../../components/top_bar";
import CommunityHeader from "../../../components/community_header";
import SortBar from "../../../components/sort_bar";
import Container from "../../../components/container";
import Wrapper from "../../../components/wrapper";
import Main from "../../../components/main";
import Sidebar from "../../../components/sidebar";
import Footer from "../../../components/footer";
import TextField from "../../../components/text_field";
import MultichoiceField from "../../../components/multichoice_field";
import {useFeedback} from "../../../store/feedback";
import {useSetCommunityCreation} from "../../../api/admin";
import {isPseudoCommunity} from "../../../store/communites";
import {themecolors} from "../../../utils/themecolors";

const Heading = styled.div``;
const Form = styled.div``;
const Save = styled.div``;

const SetCommunityCreation = styled(({className}) => {

    const community = useBaseCommunity();
    const [settings, setSettings] = useState({
        author: '',
    });
    const set = (name) => (value) => setSettings((settings) => ({...settings, [name]: value}));

    const toast = useToast();
    const {error, feedbackCh} = useFeedback();
    const setCommunityCreation = useSetCommunityCreation(feedbackCh);
    const handleSetCommunityCreation = async () => {
        try {
            await setCommunityCreation(settings.author);
            toast({
                title: `${settings.author} can now create communities.`,
                status: 'success',
                isClosable: true,
            })
        } catch {
        }
    };

    return (
        <>
            <HeaderData title={`Community Creation Permissions — Scored`} community={community}/>
            <Header>
                <TopBar />
                {!isPseudoCommunity(community) &&
                    <>
                        <CommunityHeader community={community}/>
                    </>
                }
            </Header>
            <SortBar community={community} />
            <Container className={className}>
                <Wrapper>
                    <Main>
                        <Form>
                            <TextField
                                id='community_creation'
                                label={'Username'}
                                value={settings.author}
                                onChange={set('author')}
                                maxLength="64"
                                autoComplete="off"
                                type="text"
                                required
                            />
                            <Save onClick={handleSetCommunityCreation}>Save</Save>
                        </Form>
                    </Main>
                </Wrapper>
                <Sidebar community={community} />
            </Container>
            <Footer />
        </>
    );
})`
  ${Main} {
    padding: 16px;
  }
  ${Heading} {
    font-size: 14px;
    font-weight: 500;
  }
  ${Form} {
    margin-top: 16px;
    max-width: 520px;
  }
  ${MultichoiceField} {
    margin-bottom: 12px;
  }
  ${Save} {
    margin-top: 16px;
    border: ${({theme}) => theme.standard_border};
    background-color: ${({theme}) => theme.color.name === 'dark' ? theme.dark_field : themecolors.pure_white};
    text-align: center;
    padding: 12px;
    border-radius: 6px;
    cursor: pointer;
    width: 520px;
    max-width: 100%;
  }
`;

export default SetCommunityCreation;